import React, { type FC } from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

type AttachmentsViewerDetailProps = {
  label: string;
  value: string;
};

const AttachmentsViewerDetail: FC<AttachmentsViewerDetailProps> = ({
  label,
  value,
}) => {
  return (
    <Flex flexDirection="column" marginBottom="12px">
      <Text
        typography="labelSmall"
        mb="8px"
        style={{ color: theme.colors.charcoal700 }}
      >
        {label}
      </Text>
      <Text typography="labelMedium">{value}</Text>
    </Flex>
  );
};

export default AttachmentsViewerDetail;
